import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {StorageService} from '../services/storage/storage.service';
import {AuthenticationManager} from '../services/authentication/authenticationManager';

@Injectable()
export class AuthGuard implements CanActivate {
    private readonly selfPaths = ['/edit-profile', '/change-password'];

    constructor(private router: Router, private storageService: StorageService, private authenticationManager: AuthenticationManager) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const authenticate = await this.storageService.getAuthenticate();
        if (sessionStorage.getItem('currentUser') !== null && authenticate && authenticate.accessToken) {
            return this.allowScreen(state.url);
        }
        await this.router.navigate(['/login']);
        return false;
    }

    private allowScreen(rawUrl: string): boolean {
        const path = this.clean(rawUrl);
        if (!path || path === '/') {
            return true;
        }
        if (this.selfPaths.some((openPath) => path === openPath || path.startsWith(openPath + '/'))) {
            return true;
        }
        const screens = this.authenticationManager.getAuthenticatedUser()?.role?.screenList || [];
        if (screens.some((screen: any) => this.matches(path, screen?.screenUri))) {
            return true;
        }
        const next = screens.map((screen: any) => this.toRoute(screen?.screenUri)).find((screenPath: string) => !!screenPath);
        if (next) {
            this.router.navigateByUrl(next);
        } else {
            this.router.navigate(['/not-found']);
        }
        return false;
    }

    private matches(path: string, screenUri: string): boolean {
        const route = this.toRoute(screenUri);
        const raw = this.clean(screenUri);
        return this.covers(path, route) || this.covers(path, raw);
    }

    private covers(path: string, screen: string): boolean {
        if (!screen) {
            return false;
        }
        return path === screen || path.startsWith(screen + '/');
    }

    private toRoute(screenUri: string): string {
        const path = this.clean(screenUri);
        if (path === '/server-group') {
            return '/group';
        }
        if (path === '/ext-keys') {
            return '/keys';
        }
        return path;
    }

    private clean(url: string): string {
        if (!url) {
            return '';
        }
        let path = String(url).split('?')[0].split('#')[0];
        if (path.length > 1 && path.endsWith('/')) {
            path = path.slice(0, -1);
        }
        if (path && !path.startsWith('/')) {
            path = '/' + path;
        }
        return path;
    }
}
